module.exports = {
        srcSet: __webpack_public_path__ + "static/media/IS24_Cart-500.97833483.webp"+" 500w",
        images: [{path: __webpack_public_path__ + "static/media/IS24_Cart-500.97833483.webp",width: 500,height: 500}],
        src: __webpack_public_path__ + "static/media/IS24_Cart-500.97833483.webp",
        toString: function(){return __webpack_public_path__ + "static/media/IS24_Cart-500.97833483.webp"},
        
        width: 500,
        height: 500
      }